export const PDF = ['pdf'];

export const IMAGE = ['png', 'jpg', 'jpeg'];

export const XLSX = ['xlsx'];

export const AVATAR = ['pdf', 'xlsx'];

export const ICON = ['png', 'jpg', 'jpeg', 'svg', 'ico'];
